import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'uniqfilter',
  pure: true,
  standalone: false,
})
export class UniqFilterPipe implements PipeTransform {
  transform(items: any[], args: any): any {
    return _.uniqBy(items, args);
  }
}
